<template>
    <div>
        <b-row>
            <b-col>
                <profileCard
                    v-if="
                        partner &&
                        partner.organization &&
                        partner.authentication
                    "
                    :imageUrl="
                        partner.organization.logo &&
                        partner.organization.logo.url
                    "
                    :name="partner.authentication.userName"
                    :email="partner.authentication.email"
                    :phone="partner.authentication.phone"
                    :hasSettingBtn="true"
                    @clickOnSetting="partnerStatusEdit"
                >
                    <tablink
                        linkName="Basic Info"
                        :routePath="{
                            name: 'basic-info',
                            params: { id: partnerAllData._id },
                        }"
                    />
                    <tablink
                        linkName="Subscription"
                        :routePath="{
                            name: 'view-subscription',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Payments"
                        :routePath="{
                            name: 'payment-info',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        v-if="partnerAllData.category !== 'SELLER'"
                        linkName="My Partners"
                        :routePath="{
                            name: 'ChildPartnerList',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Orders"
                        :routePath="{
                            name: 'manage-partner-order',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Invoices"
                        :routePath="{
                            name: 'partner-view-invoice',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Statements"
                        :routePath="{
                            name: 'wallet-statement',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Users"
                        :routePath="{
                            name: 'partner-user',
                            params: { id: partner._id },
                        }"
                    />
                   
                    <tablink
                        linkName="Advertisements"
                        :routePath="{
                            name: 'Advertisement',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Commission Rules"
                        :routePath="{
                            name: 'view-commission',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Delivery Preferences"
                        :routePath="{
                            name: 'delivery-preference',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Promotion Preference"
                        :routePath="{
                            name: 'promotion-preference',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Rating & Review"
                        :routePath="{
                            name: 'Rating & Reviews',
                            params: { id: partner._id },
                        }"
                    />
                    <tablink
                        linkName="Return and Cancellation Policy"
                        :routePath="{
                            name: 'Return and Cancellation Policy',
                            params: { id: partner._id },
                        }"
                    />
                </profileCard>
                <div v-else class="py-4 text-center">Loading partner...</div>
            </b-col>
        </b-row>
        <b-modal id="statusEdit" size="md" centered hide-header hide-footer>
            <div class="px-4 pb-3 pt-1">
                <b-row>
                    <b-col>
                        <p class="modal-head">Account Management</p>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <eb-select
                            type="select"
                            label="text"
                            id="userStatus"
                            v-model="selectedStatus"
                            :options="['ACTIVE', 'INACTIVE', 'CANCELLED']"
                            :selected="selectedStatus"
                            @input="changeStatus"
                        ></eb-select>
                    </b-col>
                    <b-col class="d-flex justify-content-center">
                        <p class="text">State of Connectivity</p>
                        <c-switch
                            @change="toggleActivity"
                            :value="
                                partnerAllData
                                    ? partnerAllData.isOffline
                                    : false
                            "
                            color="primary"
                            :inverse="true"
                            class="mx-2 mt-2"
                            variant="pill"
                        >
                        </c-switch>
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-center px-5 mt-3">
                    <b-button
                        class="mr-2 py-2 delete-bg-color"
                        @click="cancelModal"
                        ><span class="btn-text" variant="danger"
                            >CANCEL</span
                        ></b-button
                    >
                    <b-button
                        class="ml-2 py-2 update-bg-color"
                        @click="updatePartnerStatus"
                        ><span class="btn-text">UPDATE</span></b-button
                    >
                </b-row>
                <b-row class="px-5 mt-3 d-flex justify-content-center">
                    <b-button
                        class="py-2 delete-bg-color"
                        @click="deletePartner(partnerAllData)"
                        ><span class="btn-text">DELETE PARTNER</span></b-button
                    >
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select";
import tablink from "@/components/Common/tablink";
import { Switch as cSwitch } from "@/components/Switch";
import profileCard from "@/components/Generics/profileCard.vue";
import { mapGetters } from "vuex";
import { methods } from "@/services";
export default {
    props: ["partner"],
    components: {
        ebSelect,
        cSwitch,
        tablink,
        profileCard,
    },
    data() {
        return {
            selectedStatus: "ACTIVE",
            loading: false,
        };
    },
    computed: {
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
        }),
    },
    methods: {
        partnerStatusEdit() {
            this.$root.$emit("bv::show::modal", "statusEdit");
        },
        async changeStatus() {
            this.$store.commit("partner/setEditedPartnerData", {
                ...this.partnerAllData,
                isOffline: this.selectedStatus !== "ACTIVE",
                status: this.selectedStatus,
            });
        },
        async toggleActivity() {
            let partnerData = { ...this.partnerAllData };
            delete partnerData.isOffline;
            this.$store.commit("partner/setEditedPartnerData", {
                ...partnerData,
                isOffline: !this.partnerAllData.isOffline,
            });
        },
        cancelModal() {
            this.$root.$emit("bv::hide::modal", "statusEdit");
        },
        async updatePartnerStatus() {
            await this.$store.dispatch("partner/offlinePartner", {
                id: this.partnerAllData._id,
                data: {
                    isOffline: this.partnerAllData.isOffline,
                },
            });
            await this.$store
                .dispatch("partner/partnerStatusUpdate", {
                    id: this.partnerAllData._id,
                    data: {
                        status: this.selectedStatus,
                    },
                })
                .then((res) => {
                    this.$root.$emit("bv::hide::modal", "statusEdit");
                    this.$toasted.success("Partner Updated Successfully");
                })
                .catch((err) => {
                    this.$swal({
                        title: "Error",
                        text: "Could not Edited partner",
                        type: "error",
                    });
                });
        },
        deletePartner(data) {
            this.$swal({
                title: "Delete this Partner?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                denyButtonText: "No",
                confirmButtonColor: "#ff3a3a",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("partner/deletePartner", data._id)
                        .then((result) => {
                            this.$toasted.success(
                                "Partner Deleted Successfully",
                            );
                            this.$router.push("/partner");
                        })
                        .catch((error) => {
                            this.$toasted.error(error.message);
                        });
                }
            });
        },
    },
    async mounted() {
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        
        if (this.partnerAllData) {
            this.selectedStatus = this.partnerAllData.status;
        }
    }
    },
};
</script>

<style scoped>
.update-bg-color {
    background-color: #403fe0;
    border: 1px solid #403fe0;
}
.cancel-border-clr {
    border: 1px solid #403fe0;
    background-color: #fff;
    color: #403fe0;
}
.cancel-border-clr span {
    font-weight: 500 !important;
}
.cancel-border-clr:hover {
    border: 1px solid #403fe0;
    background-color: #403fe0;
    color: #fff;
    font-weight: 400;
}

.delete-bg-color {
    background-color: #ff3a3a;
    border: 1px solid #ff3a3a;
}

.modal-head {
    font-size: 20px;
    font-weight: 600;
    color: #403fe0;
    margin-bottom: 0px;
}
.btn-text {
    font-size: 14px;
    font-weight: 400;
}
.text {
    font-size: 13px;
    font-weight: 500;
    margin-top: 14px;
}


</style>
